import React from 'react'

const External = () => {
  return (
    <div>External</div>
  )
}

export default External